export default __webpack_public_path__ + "static/media/cediahero.46c8bb68.jpg";